// src/Boton.js
import React from 'react';
import './Boton.css';

export function Boton({ tipo = 'primario', texto, onClick, size = 'normal', disabled = false }) {
  const clases = `boton ${tipo} ${size}`;
  return (
    <button className={clases} onClick={disabled ? undefined : onClick} disabled={disabled}>
      {texto}
    </button>
  );
}